import dustinImg from './Images/DT_Picture.png';
import anthonyImg from './Images/AT_Picture.png';
import NavBar from './NavBar';
import "./OurTeam.css";

function OurTeam() {
    return (
        <div className="OurTeam">
            <NavBar />

            <div className="PageTitleBanner">
                <h1>Our Team</h1>
            </div>

            <div className="TeamMembers">
                <div className="TeamMember">
                    <div className="TeamMemberImage">
                        <img src={dustinImg} alt="Dustin Torr" />
                    </div>
                    <div className="TeamMemberInfo">
                        <div className="NameRow">
                            <h3>Dustin Torr</h3>
                            <span className="Qualification">CA (SA)</span>
                        </div>
                        <p>Dustin is a Co-Founder of Oakmere Capital. Prior to establishing Oakmere, he gained valuable experience at Stonehage Fleming, one of the world's leading international family offices. During his tenure, Dustin worked within the family office environment, advising and servicing prominent families and wealth creators across South Africa.</p>
                        <p>Before joining Stonehage Fleming, Dustin completed his articles at PwC in Cape Town, where he successfully passed the required board examinations.</p>
                        <p>Dustin holds a Bachelor of Accounting and a Bachelor of Accounting Honours from Stellenbosch University and is a qualified Chartered Accountant (SA).</p>
                    </div>
                </div>

                <div className="TeamMember">
                    <div className="TeamMemberImage">
                        <img src={anthonyImg} alt="Anthony Torr" />
                    </div>
                    <div className="TeamMemberInfo">
                        <div className="NameRow">
                            <h3>Anthony Torr</h3>
                            <span className="Qualification">CFA</span>
                        </div>
                        <p>Anthony is the Founder of YPW and Co-Founder of Oakmere Capital. Prior to establishing YPW in 2018, he gained extensive experience at Stonehage Fleming, one of the world's leading international family offices.</p>
                        <p>During his tenure at Stonehage Fleming, Anthony was responsible for multi-asset investment strategy and research in South Africa. His key responsibilities included portfolio construction, manager research and selection, and coordinating international portfolio strategy with the investment team based in London. He also managed select client relationships and investment portfolios, while supporting the broader client team on more complex and technical client mandates.</p>
                        <p>Before joining Stonehage Fleming in 2012, Anthony worked as a securities trader at Golding, Torr & De Decker, where he traded equities and derivatives listed on the JSE and managed a select number of client relationships.</p>
                        <p>Anthony holds a Bachelor of Commerce in Investment and Financial Management from Stellenbosch University and is a CFA Charterholder.</p>
                    </div>
                </div>
            </div>
            <footer className="ComplianceFooter">
                <p>Oakmere Capital is a Juristic Representative of Yellowwood Private Wealth. Yellowwood Private Wealth is an authorised financial services provider.</p>
                <p>FSP No 49879</p>
                <p>Copies of our complaints and conflicts of interest policies are available upon request.</p>
            </footer>
        </div>
    )
}

export default OurTeam;
